module.exports = __webpack_public_path__ + "static/assets/a09e525028ca2e44535975e0d4d6f644.png";